export class Participant{
  participantid: string;
  role: string;
  lastname:  string;
  eventid:  string;
  firstname:  string;
  mobilephoneprimary:  string;
  nameToSearch:  string;
  mobilephonesecondary:  string;
  barcodes:  string;  
}